import {createEvent, createStore} from 'effector';

const $visible = createStore(false);
const $content = createStore('hmm');
const on = {
    open: createEvent(),
    hide: createEvent()
};

// Handler to set visible true
$visible.on(on.open, () => {
    document.documentElement.setAttribute('data-showmodal', 'true');
    document.documentElement.setAttribute('data-shimlayer', 'true');
    return true;
});

// Handler to set visible false
$visible.on(on.hide, () => {
    document.documentElement.removeAttribute('data-showmodal');
    document.documentElement.removeAttribute('data-shimlayer');
    return false;
});

on.open.watch(data => {
    $content.setState(data);
});

on.hide.watch(() => {
    $content.setState('');
});

const modalform = {
    $visible,
    $content,
    on,
};

export default modalform;
